import React from 'react'
import { getGroupTheme, runColumnLabel } from '../../../constants/PulseCheckAnalyticsConstants'
import Chart from 'react-apexcharts'
import { useTranslation } from 'react-i18next'
var de = require('apexcharts/dist/locales/de.json')
var en = require('apexcharts/dist/locales/en.json')
var es = require('apexcharts/dist/locales/es.json')

function TrendsCard({ width = '100%', height = 300, trend = [], groups = [] }) {
    const { t, i18n } = useTranslation()

    const legend = groups.map((group, index) => ({ group, color: getGroupTheme(group, index).color }))

    // One column per pulse run (trend bucket); x-axis is categorical.
    const categories = (trend || []).map((bucket, index) => runColumnLabel(bucket, index, t('Run')))

    const newSeries = groups.map((group) => ({
        name: group,
        data: (trend || []).map((bucket) => bucket.groups?.[group] ?? null),
    }))

    const newColors = legend.map((item) => item.color)

    var options = {
        series: newSeries,
        chart: {
            id: 'chart2',
            width,
            type: 'line',
            animations: {
                initialAnimation: {
                    enabled: true,
                },
            },
            toolbar: {
                autoSelected: 'pan',
                show: false,
            },
            locales: [de, en, es],
            defaultLocale: i18n.language,
        },
        colors: newColors,
        stroke: {
            curve: 'smooth',
            width: 2,
        },
        markers: {
            size: 4,
            colors: ['#fff'],
            strokeColors: newColors,
            strokeWidth: 2,
            hover: { sizeOffset: 2 },
        },
        legend: {
            position: 'top',
            horizontalAlign: 'left',
            fontSize: '12px',
            fontFamily: 'Quicksand',
            fontWeight: 500,
            textTransform: 'capitalize',
            labels: {
                colors: ['#413F5E'],
                useSeriesColors: false,
                // textTransform: 'capitalize',
            },
            show: false,
        },
        xaxis: {
            type: 'category',
            categories,
            tooltip: {
                enabled: false,
            },
            labels: {
                style: {
                    fontFamily: 'Quicksand',
                    fontWeight: 500,
                },
            },
        },
        yaxis: {
            min: 0,
            max: 5,
            tickAmount: 5,
            title: {
                text: t('Average response (1–5)'),

                style: {
                    fontFamily: 'Quicksand',

                    fontSize: '11px',

                    color: '#9392AD',
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
                fontFamily: 'Quicksand',
            },
        },
    }
    return (
        <div className="flex-1 min-w-0 bg-white rounded-2xl py-[22px] px-[24px] border border-[#ECEBF8] shadow-[0_12px_30px_rgba(45,43,69,0.06),0_1px_0_rgba(45,43,69,0.02)]">
            <div className="flex items-start justify-between mb-3 gap-4 flex-wrap">
                <div>
                    <div className="font-bold text-[18px] text-[#413F5E]">{t('Trends Over Time')}</div>
                    <div className="font-medium text-[12px] text-[#9392AD]">{t('Average response (1–5) · one column per pulse run')}</div>
                </div>
                <div className="flex items-center gap-2 flex-wrap justify-end">
                    {legend.map((item) => (
                        <span
                            key={item.group}
                            className="inline-flex items-center gap-2 py-[6px] px-[14px] bg-white border border-[#ECEBF8] rounded-full shadow-[0_2px_6px_rgba(45,43,69,0.04)]"
                        >
                            <span className="w-[10px] h-[10px] rounded-full" style={{ background: item.color }} />
                            <span className="font-semibold text-[12px] text-[#413F5E]">{t(item.group)}</span>
                        </span>
                    ))}
                </div>
            </div>
            <Chart series={newSeries} height={height} options={options} />
        </div>
    )
}

export default TrendsCard
